package br.com.htms.inspeccaocampo.data.checklist

/**
 * Requisitos de mobilização MEV (fonte: `requisitos AXIA.xlsx`).
 * Exibidos no topo do checklist Inspeção Axia.
 */
object AxiaRequisitosMev {
    const val TITULO = "Requisitos de Mobilização de MEV"

    const val DETALHE_CL =
        "Check List (CL) — Todos os itens do CL precisam ser respondidos (C, NC ou NA). " +
            "O CL que apresentar ausência de pelo menos uma resposta deverá ser considerado incompleto."

    /**
     * Excel DETALHES (veículos + CRLV) alinhado ao checklist Axia:
     * "CRLV (impresso ou eletrônico)".
     */
    const val DETALHE_VEICULOS =
        "Veículos: além do checklist, devem ser disponibilizadas as fotos solicitadas e o CRLV " +
            "(impresso ou eletrônico), se tratando de veículos."

    val DETALHES: List<String> = listOf(DETALHE_CL, DETALHE_VEICULOS)

    const val DOC_CRLV_ROTULO = "CRLV (impresso ou eletrônico)"

    const val REQUISITO_PADRAO =
        "Plano de manutenção e evidência das manutenções realizadas."

    const val OBS1 =
        "Para os check lists não disponibilizados pela AXIA, o fornecedor irá inserir seu próprio checklist. " +
            "Para estes casos, os requisitos serão o plano de manutenção e as evidências de suas realizações."

    const val OBS2 =
        "Plano de manutenção — requisitos mínimos:\n" +
            "1 — Nome do equipamento\n" +
            "2 — Identificação do equipamento\n" +
            "3 — Tipo de manutenção (ex.: preventiva)\n" +
            "4 — Periodicidade prevista (também vale medição por quilometragem, frequência, regularidade, " +
            "constância, intermitência ou outro método aplicável).\n" +
            "5 — Responsável Técnico pelo plano\n\n" +
            "Evidência das manutenções realizadas:\n" +
            "Qualquer documento com data e responsável que evidencie a manutenção do plano " +
            "(laudos, relatórios técnicos, notas fiscais, contratos). " +
            "Deve ficar clara a relação: Plano de manutenção + evidência + equipamento mobilizado."

    /** Requisito obrigatório por nome aproximado do tipo Axia. */
    private val porEquipamento: List<Pair<String, String>> = listOf(
        "basculante" to "Caminhão basculante: Plano de manutenção e evidência das manutenções realizadas",
        "garra" to "Caminhão Garra: Plano de manutenção e evidência das manutenções realizadas",
        "guindauto" to "Caminhão Guindauto (Munck): Plano de manutenção e evidência das manutenções realizadas",
        "munck" to "Caminhão Guindauto (Munck): Plano de manutenção e evidência das manutenções realizadas",
        "roll" to "Caminhão Roll on Roll Off: Plano de manutenção e evidência das manutenções realizadas",
        "romeu" to "Caminhão Romeu e Julieta: Plano de manutenção e evidência das manutenções realizadas",
        "sucção" to "Caminhão Tanque - Sucção: Plano de manutenção e evidência das manutenções realizadas",
        "succao" to "Caminhão Tanque - Sucção: Plano de manutenção e evidência das manutenções realizadas",
        "tanque" to "Caminhão Tanque - Sucção: Plano de manutenção e evidência das manutenções realizadas",
        "prancha" to "Carreta Prancha: Plano de manutenção e evidência das manutenções realizadas",
        "empilhadeira" to "Empilhadeira: Plano de manutenção e evidência das manutenções realizadas",
        "escavadeira" to "Escavadeira em Garra: Plano de manutenção e evidência das manutenções realizadas",
        "guindaste" to "Caminhão Guindaste: Plano de manutenção e evidência das manutenções realizadas",
        "concha" to "Pá carregadeira com concha: Plano de manutenção e evidência das manutenções realizadas",
        "garfo" to "Pá carregadeira com garfo: Plano de manutenção e evidência das manutenções realizadas",
        "pemt" to "Plataforma elevatória - PEMT: Plano de manutenção e evidência das manutenções realizadas",
        "plataforma" to "Plataforma elevatória - PEMT: Plano de manutenção e evidência das manutenções realizadas",
        "jacaré" to "Prensa Jacaré: Plano de manutenção e evidência das manutenções realizadas",
        "jacare" to "Prensa Jacaré: Plano de manutenção e evidência das manutenções realizadas",
        "prensa vertical" to "Prensa Vertical: Plano de manutenção e evidência das manutenções realizadas",
        "retroescavadeira" to "Retroescavadeira: Plano de manutenção e evidência das manutenções realizadas",
        "picador" to "Picador / Triturador de Madeira: Plano de manutenção e evidência das manutenções realizadas",
        "triturador" to "Picador / Triturador de Madeira: Plano de manutenção e evidência das manutenções realizadas",
        "leve" to "Veículos Leves/Utilitários: Plano de manutenção e evidência das manutenções realizadas",
        "utilit" to "Veículos Leves/Utilitários: Plano de manutenção e evidência das manutenções realizadas",
        "ônibus" to "Ônibus e micro-ônibus (transporte coletivo): Plano de manutenção e evidência das manutenções realizadas e disponibilização de telemetria",
        "onibus" to "Ônibus e micro-ônibus (transporte coletivo): Plano de manutenção e evidência das manutenções realizadas e disponibilização de telemetria",
        "micro" to "Ônibus e micro-ônibus (transporte coletivo): Plano de manutenção e evidência das manutenções realizadas e disponibilização de telemetria",
        "brook" to "Caminhão Brook Simples e Duplo: Plano de manutenção e evidência das manutenções realizadas",
        "guincho" to "Caminhão Guincho Plataforma: Plano de manutenção e evidência das manutenções realizadas",
        "mini carregadeira" to "Mini Carregadeira: Plano de manutenção e evidência das manutenções realizadas",
        "betoneira" to "Caminhão Betoneira: Plano de manutenção e evidência das manutenções realizadas",
        "ambulância" to "Ambulância: Plano de manutenção e evidência das manutenções realizadas",
        "ambulancia" to "Ambulância: Plano de manutenção e evidência das manutenções realizadas",
        "esmerilhadeira" to "Esmerilhadeira: Plano de manutenção e evidência das manutenções realizadas",
        "lixadeira" to "Lixadeira: Plano de manutenção e evidência das manutenções realizadas",
        "furadeira" to "Furadeira: Plano de manutenção e evidência das manutenções realizadas",
        "oxiacetileno" to "Conjunto Oxiacetileno: Plano de manutenção e evidência das manutenções realizadas",
        "roçadeira" to "Roçadeira / Motopoda: Plano de manutenção e evidência das manutenções realizadas",
        "rocadeira" to "Roçadeira / Motopoda: Plano de manutenção e evidência das manutenções realizadas",
        "motopoda" to "Roçadeira / Motopoda: Plano de manutenção e evidência das manutenções realizadas",
        "motosserra" to "Motosserra: Plano de manutenção e evidência das manutenções realizadas",
        "outros caminh" to "Outros Caminhões: Plano de manutenção e evidência das manutenções realizadas"
    )

    fun requisitoParaTipo(tipoNome: String): String {
        val lower = tipoNome.lowercase()
        return porEquipamento.firstOrNull { (chave, _) -> lower.contains(chave) }?.second
            ?: "Equipamento: $REQUISITO_PADRAO"
    }

    /**
     * CRLV obrigatório para tipos veiculares (paridade ChecklistDiario / planilha Axia).
     * Equipamentos sem CRLV (ferramentas, PEMT, empilhadeira, etc.) retornam false.
     */
    fun exigeCrlv(tipoNome: String): Boolean {
        if (tipoNome.isBlank()) return false
        val lower = tipoNome.lowercase()
        val semCrlv = listOf(
            "empilhadeira", "escavadeira", "concha", "garfo", "pemt", "plataforma",
            "jacaré", "jacare", "prensa", "retroescavadeira", "picador", "triturador",
            "mini carregadeira", "esmerilhadeira", "lixadeira", "furadeira",
            "oxiacetileno", "roçadeira", "rocadeira", "motopoda", "motosserra"
        )
        if (semCrlv.any { lower.contains(it) }) return false
        val comCrlv = listOf(
            "caminh", "veículo", "veiculo", "utilit", "leve", "ônibus", "onibus",
            "micro", "ambul", "betoneira", "guincho", "guindaste", "guindauto",
            "munck", "prancha", "brook", "roll", "romeu", "tanque", "basculante",
            "garra", "sucção", "succao"
        )
        return comCrlv.any { lower.contains(it) }
    }
}
